import React from "react";
import { StripeContainer } from "./StripeContainer";

const Checkout = () => {
  return (
    <>
      <StripeContainer />
    </>
  );
};

export default Checkout;
